module.exports = __webpack_public_path__ + "img/苗.0144315f.gif";